var _mask, _path, _path2, _path3, _mask2, _rect, _mask3, _rect2, _mask4, _rect3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareHouse = function SvgShareHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "share-house_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 30.43a.43.43 0 0 1 .43-.43h4.14a.43.43 0 0 1 .43.43v6.141a.43.43 0 0 1-.429.429H18.43a.43.43 0 0 1-.429-.429z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 30.43c0-.79.64-1.43 1.43-1.43h4.14c.79 0 1.43.64 1.43 1.43L22 31h-3zM23 37h-5zm-4.571 0c-.79 0-1.429-.64-1.429-1.429V30.43c0-.79.64-1.43 1.43-1.43l.57 2v6zm4.141-8c.79 0 1.43.64 1.43 1.43v5.141c0 .79-.64 1.429-1.429 1.429H22v-6z",
    mask: "url(#share-house_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M25 9 12.5 19.929v17.357h24.857V19.714z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M24 16h2"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "share-house_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 17,
    y: 20,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 17,
    y: 20,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#share-house_svg__b)",
    rx: 0.383
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "share-house_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 27,
    y: 20,
    rx: 0.383
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 27,
    y: 20,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#share-house_svg__c)",
    rx: 0.383
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "share-house_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 27,
    y: 30,
    rx: 0.383
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 27,
    y: 30,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#share-house_svg__d)",
    rx: 0.383
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M30 31v2M18 23h4M28 23h4M19.994 20.996v4M29.994 20.996v4"
  })));
};
export default SvgShareHouse;